module.exports = __webpack_public_path__ + "static/media/logo-2.ea8cfd71.png";